import React, { useEffect, useState } from 'react'
import { PointOfSaleReportAdhocDetail } from '../../features/invoice/invoiceAPI'

// Kendo components
import { Dialog } from '@progress/kendo-react-dialogs'
import { Form, FormElement } from '@progress/kendo-react-form'
import { FastQuoteInput, FastQuoteDropdownList } from '../../GlobalComponents/Inputs/Inputs'
import { FormDate } from './FormInput'

import styles from '.././PointOfSaleManager.module.scss'
import inputStyles from '../../GlobalComponents/Inputs/Inputs.module.scss'
import modalStyles from '../../GlobalComponents/GenericModals/GenericModals.module.scss'
import ModalTitleBar from './ModalTitleBar'
import { AWCButton, BUTTON_TYPES } from '../../GlobalComponents/Inputs/Inputs'
import { Vendors, fetchVendorData } from '../../features/inventory/inventoryAPI'
import {
    NotificationManager,
    fqAlert,
} from '../../GlobalComponents/NotificationManager/NotificationManager'
import Switch from 'rc-switch'
import { TreeListNumericFilter } from '@progress/kendo-react-treelist'

export const PointOfSaleAdhocModal: React.FC<{
    pointOfSaleReportAdhocDetail?: PointOfSaleReportAdhocDetail
    cancelEdit: () => void
    onSubmit: (event: any) => void
    handleVendorIDChange: (event: any) => void
    handleEmailRecipientsChange: (event: any) => void
    handleEmailCCRecipientsChange: (event: any) => void
    handleIncludeFieldnamesChange: (event: any) => void
    handleFromDateChange: (event: any) => void
    handleToDateChange: (event: any) => void
}> = (props) => {
    const [dropdownData, setDropdownData] = useState<any>([])

    useEffect(() => {
        async function getVendorData() {
            let vendData: Vendors = await fetchVendorData()

            const vendorList: any = []
            vendData.forEach((vendor) => {
                const tempList: any = []
                tempList.push(vendor.VendorID)
                tempList.push(vendor.VendorIDName)
                vendorList.push(tempList)
            })
            setDropdownData(vendorList)
        }
        getVendorData()
    }, [])

    return (
        <Dialog className='PointOfSaleAdhocModal'>
            {props.pointOfSaleReportAdhocDetail && (
                <Form
                    onSubmitClick={props.onSubmit}
                    initialValues={props.pointOfSaleReportAdhocDetail}
                    render={(formRenderProps) => {
                        return (
                            <FormElement>
                                <ModalTitleBar
                                    close={props.cancelEdit}
                                    title={
                                        props.pointOfSaleReportAdhocDetail!.reportName +
                                        ' Ad Hoc Report'
                                    }
                                />
                                <div>
                                    <FastQuoteInput
                                        length='medium'
                                        title='Name'
                                        name='reportName'
                                        value={props.pointOfSaleReportAdhocDetail?.reportName}
                                        maxLength={50}
                                        style={{ marginTop: 25 }}
                                        disabled={true}
                                    />
                                </div>

                                {props.pointOfSaleReportAdhocDetail?.reportType === 'Standard' && (
                                    <div>
                                        <div className={styles.dropDownTitle}>
                                            Vendor ID&nbsp;
                                            <span className={styles.required}>*</span>
                                        </div>
                                        <div>
                                            <FastQuoteDropdownList
                                                title='Vendor ID'
                                                name='vendorID'
                                                style={{ marginTop: 50 }}
                                                value={props.pointOfSaleReportAdhocDetail?.vendorID}
                                                selectList={dropdownData}
                                                onChange={props.handleVendorIDChange}
                                                editingShippingOption={'Custom'}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className={styles.wrap}>
                                    <FormDate
                                        label='From Date'
                                        name='fromDate'
                                        required={true}
                                        dateAsDate={props.pointOfSaleReportAdhocDetail?.fromDate!}
                                        onDateChange={props.handleFromDateChange}
                                    />
                                    <FormDate
                                        label='To Date'
                                        name='toDate'
                                        required={true}
                                        dateAsDate={props.pointOfSaleReportAdhocDetail?.toDate!}
                                        onDateChange={props.handleToDateChange}
                                    />
                                </div>
                                <div>
                                    <FastQuoteInput
                                        length='medium'
                                        title='Email To'
                                        value={props.pointOfSaleReportAdhocDetail?.emailRecipients}
                                        required={true}
                                        useNativeOnChange={true}
                                        onChange={props.handleEmailRecipientsChange}
                                        maxLength={440}
                                        style={{ marginTop: 25 }}
                                    />
                                </div>
                                <div>
                                    <FastQuoteInput
                                        length='medium'
                                        title='Email CC'
                                        value={
                                            props.pointOfSaleReportAdhocDetail?.emailCCRecipients
                                        }
                                        required={false}
                                        useNativeOnChange={true}
                                        onChange={props.handleEmailCCRecipientsChange}
                                        maxLength={440}
                                        style={{ marginTop: 25 }}
                                    />
                                </div>

                                {props.pointOfSaleReportAdhocDetail?.reportType === 'Standard' && (
                                    <div>
                                        <div className={inputStyles.inputTitle}>
                                            Include Field Names{' '}
                                        </div>
                                        <div style={{ maxWidth: 100, fontSize: 12 }}>
                                            <Switch
                                                className={styles.rcSwitch}
                                                checkedChildren='Yes'
                                                unCheckedChildren='No'
                                                checked={
                                                    props.pointOfSaleReportAdhocDetail
                                                        ?.includeFieldnames
                                                }
                                                onChange={props.handleIncludeFieldnamesChange}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <div
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: '110px 110px',
                                            marginTop: 10,
                                        }}
                                    >
                                        <AWCButton
                                            type={'secondary'}
                                            onClick={props.cancelEdit}
                                            style={{
                                                width: 94,
                                            }}
                                        >
                                            Cancel
                                        </AWCButton>
                                        <AWCButton
                                            type={BUTTON_TYPES.PRIMARY}
                                            onClick={formRenderProps.onSubmit}
                                            style={{
                                                width: 94,
                                            }}
                                        >
                                            Submit
                                        </AWCButton>
                                    </div>
                                </div>
                            </FormElement>
                        )
                    }}
                />
            )}
        </Dialog>
    )
}
